import {
    RESET_STATE,
    SET_DATA,
    SET_ACTIVE_MAP_DATA,
    SET_CURRENT_ITEM,
    SET_CURRENT_ITEM_LOGS,
    SET_CURRENT_ITEM_ADDRESS,
    SET_GEO_MAP,
    SET_ACTIVE_BADGE,
    SET_ACTIVE_TAB,
    HIDE_BADGE,
    SORT_BY_CENTRE_SEARCH_MAP,
    FINDING_NEAR_POINT_MAP,
    CREATE_DUBL_POINT,
    UPDATE_DEVICE_INFO,
    SET_CURRENT_ITEM_CHANGE_ACTIVE, SET_CURRENT_ITEM_LOADER_LOGS, SELECT_DEVICES_CURRENT_COMPANY, CLEAR_CURRENT_ITEM, UPDATE_ALL_DEVICES_SUB_INFO,
    SET_LOAD_DATA
} from "../action/page";
import {averageDataLogs, chartOne, chartTwo, colors, getAqiColor, getRangeLevel, haversineDistance, tooltypeChartTwo} from "../util/util";
import TooltypeChartTwo from "../components/menu/tooltypeChartTwo";
import {
    carelessFace,
    carelessFaceBlack,
    goodFace,
    goodFaceBlack, hazardousFace, hazardousFaceBlack,
    moderateFace,
    moderateFaceBlack, unhealthyFace, unhealthyFaceBlack, veryUnhealthyFace, veryUnhealthyFaceBlack
} from "../util/assets";
import moment from "moment-timezone";
import {ADD_DEVICE_BY_SOCKET} from "../action/alert";


const stateModal = {
    state: "default",
    menu: [
        // {
        //     title: 'Settings',
        //     link: '/settings',
        //     access: "superAdmin,tester,admin",
        //     active: false
        // },
    ],
    currentItem: {
        chartOne: {
            type: "",
            xLabels: {
                // min: 0,
                // max: 100,
                // step: 0,
                customLabels: ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5", "Day 6", "Day 7"]
            },
            dataset: [],
            yLabels: {
                // min: 0,
                // max: 100,
                // step: 0,
                // customLabels: []
            }
        },
        chartTwo: {
            type: "group",
            xLabels: {
                // min: 0,
                // max: 100,
                // step: 0,
                customLabels: ["Day 1", "Day 2", "Day 3", "Day 4", "Day 5", "Day 6", "Day 7"]
            },
            dataset: [],
            yLabels: {
                // min: 0,
                // max: 100,
                // step: 0,
                customLabels: ["12 am", "2 am", "4 am", "6 am", "8 am", "10 am", "12 pm", "2 pm", "4 pm", "6 pm", "8 pm", "10 pm"]
            }
        },
        address: "",
        index: null,
        active: false,
        loaderLogs: false
    },
    data: undefined,
    query: {},
    subData: {},
    pagination: {
        // page: 1,
        // limit: 20
    },
    map: {
        firstLoad: true,
        typeIcon: "big" // big, small
    },
    activeTab: "aqi",
    loadData: "0",
    badges: [
        {
            title: "Good",
            description: "Air quality is considered satisfactory, and air pollution poses little or no risk",
            icon: goodFace,
            iconContent: goodFaceBlack,
            class: "goodFace",
            color: "#53BE53",
            active: false
        },
        {
            title: "Moderate",
            description: "Air quality is acceptable, however, for some pollutants there may be a moderate health concern for a very small number of people who are unusually sensitive to air pollution",
            icon: moderateFace,
            iconContent: moderateFaceBlack,
            class: "moderateFace",
            color: "#F6E604",
            active: false
        },
        {
            title: "Unhealthy for Sensitive Groups",
            description: "Members of sensitive groups may experience health effects. The general public is not likely to be affected",
            icon: carelessFace,
            iconContent: carelessFaceBlack,
            class: "carelessFace",
            color: "#FEA100",
            active: false
        },
        {
            title: "Unhealthy",
            description: "Everyone may begin to experience health effects; members of sensitive groups may experience more serious health effects",
            icon: unhealthyFace,
            iconContent: unhealthyFaceBlack,
            class: "unhealthyFace",
            color: "#EC3303",
            active: false
        },
        {
            title: "Very Unhealthy",
            description: "Health warnings of emergency conditions. The entire population is more likely to be effected",
            icon: veryUnhealthyFace,
            iconContent: veryUnhealthyFaceBlack,
            class: "veryUnhealthyFace",
            color: "#980075",
            active: false
        },
        {
            title: "Hazardous",
            description: "Health alert. Everyone may experience more serious health effects",
            icon: hazardousFace,
            iconContent: hazardousFaceBlack,
            class: "hazardousFace",
            color: "#7D0022",
            active: false
        }
    ],
    loader: 0
}

const applyRangeLevels = (data, max, min) => {
    const values = Object.values(data)
        .map(item => item?.value)
        .filter(value => value !== undefined && value !== null && !Number.isNaN(value));
    if (!values.length) return data;
    // const min = Math.min(...values);
    // const max = Math.max(...values);
    Object.keys(data).forEach(key => {
        data[key].level = getRangeLevel(data[key].value, min, max);
    });
    return data;
}

function page(state = stateModal, action) {
    switch (action && action.type) {
        case RESET_STATE:
            state.state = "default";
            return {...state};
        case UPDATE_ALL_DEVICES_SUB_INFO:
            const {companyId} = action.data;
            state.data = state.data.map(item => {
                item.showSubInfo = item.companyId === companyId ? true : false;
                return item;
            })
            return {...state};
        case SELECT_DEVICES_CURRENT_COMPANY: {
            let {companyId} = action.data;
            state.data = state.data.map(item => {
                if (item.companyId === companyId || companyId === "all") {
                    return {...item, showOnMap: true}
                }
                return {...item, showOnMap: false}
            });

            return {...state};
        }
        case SET_DATA: {
            state.data = action.data.data.map(item => {
                return {...item, showOnMap: true, showSubInfo: false}
            });

            state.state = action.data.state;
            return {...state};
        }
        case SET_ACTIVE_MAP_DATA: {
            let indexAction = action.data.index;
            state.data = state.data.map((item, index) => {
                if(indexAction === index) {
                    item.active = !item.active;
                } else {
                    item.active = false;
                }
                return item;
            })
            state.currentItem.index = indexAction;
            // state.data[index].active = !state.data[index].active;
            return {...state};
        }
        case SET_CURRENT_ITEM_LOGS: {
            let logs = action.data;
            let resLog = {};
            state.currentItem.logs = logs;
            
            let logsKeys = Object.keys(logs);
            let aqiValue = logs[logsKeys[logsKeys.length - 1]][logs[logsKeys[logsKeys.length - 1]].length - 1].aqiValue;
            let aqiLevel = logs[logsKeys[logsKeys.length - 1]][logs[logsKeys[logsKeys.length - 1]].length - 1].aqiLevel;
            
            let dew = {}
            let h = {}
            let no2 = {}
            let o3 = {}
            let p = {}
            let pm25 = {}
            let so2 = {}
            let t = {}
            let w = {}
            let wg = {}
            for(let item in logs) {
                if(averageDataLogs(logs[item], "iaqi.dew")) dew[item] = {value: averageDataLogs(logs[item], "iaqi.dew"), level: 0};
                if(averageDataLogs(logs[item], "iaqi.h")) h[item] = {value: averageDataLogs(logs[item], "iaqi.h"), level: 0};
                if(averageDataLogs(logs[item], "iaqi.no2")) no2[item] = {value: averageDataLogs(logs[item], "iaqi.no2"), level: 0};
                if(averageDataLogs(logs[item], "iaqi.o3")) o3[item] = {value: averageDataLogs(logs[item], "iaqi.o3"), level: 0};
                if(averageDataLogs(logs[item], "iaqi.p")) p[item] = {value: averageDataLogs(logs[item], "iaqi.p"), level: 0};
                if(averageDataLogs(logs[item], "iaqi.pm25")) pm25[item] = {value: averageDataLogs(logs[item], "iaqi.pm25"), level: 0};
                if(averageDataLogs(logs[item], "iaqi.so2")) so2[item] = {value: averageDataLogs(logs[item], "iaqi.so2"), level: 0};
                if(averageDataLogs(logs[item], "iaqi.t")) t[item] = {value: averageDataLogs(logs[item], "iaqi.t"), level: 0};
                if(averageDataLogs(logs[item], "iaqi.w")) w[item] = {value: averageDataLogs(logs[item], "iaqi.w"), level: 0};
                if(averageDataLogs(logs[item], "iaqi.wg")) wg[item] = {value: averageDataLogs(logs[item], "iaqi.wg"), level: 0};

                let averebleAqiLevel = 0;
                let averebleAqiValue = 0;
                logs[item].forEach(i => {
                    averebleAqiLevel = averebleAqiLevel + i.aqiLevel;
                    averebleAqiValue = averebleAqiValue + i.aqiValue;
                });
                averebleAqiLevel = averebleAqiLevel/logs[item].length;
                averebleAqiValue = averebleAqiValue/logs[item].length;

                resLog[item] = {
                    aqiLevel: Math.ceil(averebleAqiLevel),
                    aqiValue: Math.ceil(averebleAqiValue)
                };
            };
            dew = applyRangeLevels(dew, 30, 0);
            h = applyRangeLevels(h, 100, 0);
            no2 = applyRangeLevels(no2, 500, 0);
            o3 = applyRangeLevels(o3, 300, 0);
            p = applyRangeLevels(p, 1200, 0);
            pm25 = applyRangeLevels(pm25, 100, 0);
            so2 = applyRangeLevels(so2, 600, 0);
            t = applyRangeLevels(t, 50, 0);
            w = applyRangeLevels(w, 30, 0);
            wg = applyRangeLevels(wg, 30, 0);
            state.currentItem.avaribleLogs = resLog;
            state.currentItem.chartOne = chartOne(resLog);
            state.currentItem.chartTwo.data = chartTwo(logs);
            state.currentItem.dew = Object.keys(dew).length ? chartOne(dew, getAqiColor, "value", "level", "Dew Point", "°C", 30, 0) : null;
            state.currentItem.h = Object.keys(h).length ? chartOne(h, getAqiColor, "value", "level", "Humidity", "%", 100, 0) : null;
            state.currentItem.no2 = Object.keys(no2).length ? chartOne(no2, getAqiColor, "value", "level", "NO2", "µg/m³", 500, 0) : null;
            state.currentItem.o3 = Object.keys(o3).length ? chartOne(o3, getAqiColor, "value", "level", "O3", "µg/m³", 300, 0) : null;
            state.currentItem.p = Object.keys(p).length ? chartOne(p, getAqiColor, "value", "level", "Pressure", "hPa", 1200, 0) : null;
            state.currentItem.pm25 = Object.keys(pm25).length ? chartOne(pm25, getAqiColor, "value", "level", "PM2.5", "µg/m³", 100, 0) : null;
            state.currentItem.so2 = Object.keys(so2).length ? chartOne(so2, getAqiColor, "value", "level", "SO2", "µg/m³", 600, 0) : null;
            state.currentItem.t = Object.keys(t).length ? chartOne(t, getAqiColor, "value", "level", "Temperature", "°C", 50, 0) : null;
            state.currentItem.w = Object.keys(w).length ? chartOne(w, getAqiColor, "value", "level", "Wind Speed", "m/s", 30, 0) : null;
            state.currentItem.wg = Object.keys(wg).length ? chartOne(wg, getAqiColor, "value", "level", "Wind Gust", "m/s", 30, 0) : null;
            state.currentItem.active = true;
            state.currentItem.aqiValue = aqiValue;
            state.currentItem.aqi = aqiLevel;
            return {...state};
        }
        case SET_CURRENT_ITEM:
            state.currentItem = {...state.currentItem, ...action.data};
            return {...state};
        case SET_CURRENT_ITEM_ADDRESS:
            state.currentItem.address = action.data;
            return {...state};
        case SET_GEO_MAP: {
            state.map = {...state.map, ...action.data};
            return {...state};
        }
        case SET_ACTIVE_BADGE: {
            const index = state.badges.findIndex(item => item.color === action.data);
            const currentBadgeStatus = state.badges[index].activeDbl !== undefined ?
                state.badges[index].activeDbl : state.badges[index].active;

            state.badges = state.badges.map(item => {
                item.active = false;
                return item;
            })
            state.badges[index].activeDbl = !currentBadgeStatus;
            state.badges[index].active = !currentBadgeStatus;

            return {...state}
        }
        case HIDE_BADGE:
            state.badges = state.badges.map(item => {
                item.active = false;
                return item;
            })
            return {...state}
        case FINDING_NEAR_POINT_MAP: {
            let found = false;
            let currentPoint = undefined;
            if (!state.data) return {...state};

            state.data = state.data.map(item => {
                if (!item.dubl && !found && item.aqi !== undefined && item.distance <= 50) {
                    if (item.type === "parserDevice") {
                        item.active = true;
                        found = true;
                        currentPoint = item;
                    }
                }
                return item;
            });

            if (!found) {
                state.data = state.data.map(item => {
                    if (!item.dubl && !found && item.aqi !== undefined && item.distance <= 20) {
                        if (item.distance <= 20) {
                            item.active = true;
                            found = true;
                            currentPoint = item;
                        }
                    }
                    return item;
                });
            }
            state.state = "map";

            if (!currentPoint) {
                // const def = {
                //     info: "Devices not found in radius 10km",
                //     active: true
                // }
                // state.currentItem = {
                //     ...state.currentItem,
                //     ...def
                // };


                state.currentItem.active = true;
                state.state = "mapNotFound";
            } else {
                if (currentPoint.aqi !== undefined) {
                    let colorForDesc = colors[currentPoint.aqi];
                    const index = state.badges.findIndex(item => item.color.toUpperCase() === colorForDesc.toUpperCase());
                    currentPoint.description = state.badges[index].description;
                }
                // state.currentItem = {...state.currentItem, ...currentPoint};
            }
            return {...state};
        }
        case SORT_BY_CENTRE_SEARCH_MAP: {
            if (!state.data) return {...state};

            let {
                lat,
                lng
            } = !action.data && state.map && state.map.geometry && state.map.geometry.location || {
                lat: 32.07745459654768,
                lng: 34.77098132844806
            };
            const {centre} = action.data || {centre: [lat, lng]};
            let pointsMap = state.data;
            let pointsBefore10Km = [];
            pointsMap = pointsMap.reduce((acc, item) => {
                item.distance = haversineDistance(centre, item.location);
                item.active = false;
                if (!item.dubl && item.distance <= 20 && item.aqi !== undefined && item.showOnMap) {
                    pointsBefore10Km.push(item._id);
                }
                acc.push(item);
                return acc;
            }, []);

            pointsMap = pointsMap.sort((a, b) => b.distance - a.distance);
            state.data = pointsMap;
            state.pointsBefore10Km = pointsBefore10Km;
            return {...state}
        }
        case CREATE_DUBL_POINT:
            let found = false;
            let currentPoint = undefined;
            if (!state.data) return {...state};
            /**Search nearer point and build object for duplicate */
            state.data = state.data.sort((a, b) => a.distance - b.distance)
            state.data = state.data.map(item => {
                if (!item.dubl && !found && item.aqi !== undefined && item.distance <= 50) {
                    if (!currentPoint && !item.dubl) {
                        item.active = true;
                        currentPoint = {...item};
                    }
                    if (currentPoint && !currentPoint.iaqi && item.iaqi) {
                        currentPoint.iaqi = item.iaqi;
                        found = true;
                    }
                }
                return item;
            });

            if (state.state !== "mapNotFound") {
                const {centre} = action.data;
                let {data} = state;
                if (!data) return {...state};

                /**Reset all active devices and remove duplicate*/
                data = data.reduce((acc, item) => {
                    if (!item.dubl) {
                        item.active = false;
                        acc.push(item);
                    }
                    return acc;
                }, []);

                currentPoint.dubl = true;
                currentPoint.showOnMap = true;
                currentPoint.location = centre;
                currentPoint._id = currentPoint._id + "__d";
                currentPoint.active = true;
                // currentItem.address = formatted_address ||

                /**Added description aqo status to device*/
                if (currentPoint.aqi) {
                    let colorForDesc = colors[currentPoint.aqi];
                    const index = state.badges.findIndex(item => item.color === colorForDesc);
                    currentPoint.description = state.badges[index].description;
                }

                /**Added duplicate to array points on the map*/
                state.data.push(currentPoint);

                if (!currentPoint) {
                    /**If don't have near devices*/
                    const def = {
                        info: "Devices not found in radius 10km",
                        active: true
                    }
                    state.currentItem = {
                        ...state.currentItem,
                        ...def
                    };
                    state.state = "mapNotFound";
                } else {
                    /**If have near devices*/
                    if (currentPoint.aqi !== undefined) {
                        let colorForDesc = colors[currentPoint.aqi];
                        const index = state.badges.findIndex(item => item.color.toUpperCase() === colorForDesc.toUpperCase());
                        currentPoint.description = state.badges[index].description;
                    }
                    state.currentItem = {...state.currentItem, ...currentPoint};
                }
            }
            return {...state};
        case UPDATE_DEVICE_INFO:
            const deviceInfo = action.data;
            let find = false;
            if (!state.data) return {...state};
            state.data = state.data.map(item => {
                const id = item._id;
                const idReplace = item._id.indexOf("__d") !== -1 ? item._id.replace("__d", "") : id;
                // const location = item.location;
                if (idReplace === deviceInfo._id) {
                    // item._id = id;
                    find = true;
                    // delete deviceInfo.location;
                    item = {...item, ...deviceInfo};
                    // item.location = item._id.indexOf("__d") !== -1 ? location : deviceInfo.location;
                    item._id = id;
                }
                return item;
            });

            if (!find) {
                deviceInfo.active = false;
                state.data.push(deviceInfo);
            }

            if (state.currentItem._id && state.currentItem._id === deviceInfo._id) {
                if (deviceInfo.aqi && deviceInfo.aqi <= 7) {
                    let colorForDesc = colors[deviceInfo.aqi];
                    const index = state.badges.findIndex(item => item.color === colorForDesc);
                    deviceInfo.description = state.badges[index].description ? state.badges[index].description : "";
                }
                state.currentItem = {...state.currentItem, ...deviceInfo}
            }

            return {...state};
        case SET_CURRENT_ITEM_LOADER_LOGS: {
            state.currentItem.loaderLogs = action.data;
            return {...state};
        }
        case ADD_DEVICE_BY_SOCKET: {
            if (action.data.location && action.data.location.length) {
                state.data.push(action.data);
            }
            return {...state};
        }
        case SET_ACTIVE_TAB: {
            state.activeTab = action.data;
            return {...state};
        }
        case SET_LOAD_DATA: {
            state.loadData = action.data;
            return {...state}
        }
        default:
            return {...state};
    }
}

export default page;

